<template>
  <div>
    <section id="bikes-photos" class='desktop'>
      <ul v-for="(serie,name) in series" v-bind:class="getPhotosClass(name)" :key="name">
        <li v-bind:class="serie['photo_1']['overlay']">
          <div class='photo' :style="setPhoto(serie['photo_1']['photo'])"></div>
          <div class="filters"></div>
          <div class='photo-overlay'>
            <h2 v-html="serie['photo_1']['title']"></h2>
            <p v-html="name"></p>
          </div>
        </li>

        <li v-bind:class="serie['photo_2']['overlay']">
          <div class='photo' :style="setPhoto(serie['photo_2']['photo'])"></div>
          <div class="filters"></div>
          <div class='photo-overlay'>
            <h2 v-html="serie['photo_2']['title']"></h2>
            <p v-html="name"></p>
          </div>
        </li>

        <li v-bind:class="serie['photo_3']['overlay']">
          <div class='photo' :style="setPhoto(serie['photo_3']['photo'])"></div>
          <div class="filters"></div>
          <div class='photo-overlay'>
            <h2 v-html="serie['photo_3']['title']"></h2>
            <p v-html="name"></p>
          </div>
        </li>

      </ul>
    </section>

    <section id="bikes-series" class='desktop'>
      <div class="desktop series series-carousel">

      <carousel :activePage="currentPage" @update="pageChanged" :navigationEnabled="true">
          <serie-slide :key="slide_index"
            v-for="(slide_serie, slide_index) in series"
            :serie="slide_serie" :serie_id="slide_index"
            v-bind:class="'serie-' + slide_index"></serie-slide>
      </carousel>

      </div>

      <ul class="jcarousel-pagination">

        <li v-for="(serie, pagin_index) in series" v-bind:class="{active: isCurrent(pagin_index)}" >
          <a v-on:click="setActiveSlide(pagin_index)">
            <serie-symbol :serie="pagin_index"></serie-symbol>
            {{pagin_index}}
          </a>
        </li>

      </ul>

    </section>
  </div>
</template>

<script>

  import SerieSymbol from '../Graphics/SerieSymbol';
  import Carousel from './../Carousel/Carousel.vue'
  import Slide from './../Carousel/Slide.vue'
  import SerieSlide from './SerieSlide.vue'

  export default {
    mounted: function(){
      this.series = window.env.bikesSeries;
      var i = 0;
      let that = this;
      _.forEach(that.series, function(el,key){
        that.slidesIndex[i++] = key;
      });

    },

    name: 'HomePageBikesDesktop',
    components: {SerieSymbol, Carousel, Slide, SerieSlide},
    data: function() {
      return {
        slidesIndex: [],
        series: {},
        currentPage: 0
      }
    },
    methods: {
      getPhotosClass: function (name) {
        let c = 'serie-' + name;
        if(this.isCurrent(name)) c += ' active';
        return c;
      },
      setPhoto(imgName) {
        return "background-image: url('/css/images/series/desktop/" + imgName + "');";
      },
      setActiveSlide: function(slide_id)
      {
        this.currentPage = this.slidesIndex.indexOf(slide_id);
      },
      pageChanged: function (page) {
        this.currentPage = page;
      },
      isCurrent: function(slide_id) {
        let slide_index = this.slidesIndex.indexOf(slide_id);
        return slide_index == this.currentPage;
      },
      getActiveSlideByName: function ()
      {
        let activeSlide =this.slidesIndex[ this.currentPage ];
        console.log(activeSlide );
        return activeSlide;

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/HomePage/BikesSeriesDesktop.vue